export default "__VITE_ASSET__CUrS_iI7__"